/**
 * 商品调拨
 */
import { useEffect, useState } from 'react'
import {Button, Card, message, Space, Tabs} from 'antd'
import AuthComponent from "../../components/AuthComponent";
import useGetProductTransfersList from './hooks/useGetProductTransfersList'
import ProductTransfersListBasicForm from './components/ProductTransfersListBasicForm'
import TransfersListTable from './components/TransfersListTable'
import {DownloadOutlined, PlusOutlined} from "@ant-design/icons";
import service from "../../@services";
import * as Utils from "../../@utils";
const checkBillBaseKey = '/inventory/allocation/'
export default function ProductTransfers(props){
  const queryNo = props.location.query?.no
  const key = props.location.query?.activeKey || 'out'

  const getCheckNo = async () => {
    return await service.inventory.allocationGenerateNo()
  }
  const [sourceStoreCode, setSourceStoreCode] = useState(null)
  const [activeKey, setActiveKey] = useState(key)
  const [selectedItems, setSelectedItems] = useState([])
  const [exportFormData, setExportFormData] = useState({})
  const [no, setNo]= useState(queryNo)
  const { pageData, getList, loading } = useGetProductTransfersList(activeKey)
  useEffect(() => {
    setSelectedItems([])
  }, [pageData])
  const tabs = [
    {
      key: 'out',
      tab: '调出单'
    },
    {
      key: 'in',
      tab: '调入单'
    }]
  const queryBaseList = ({ formData }) => {
    getList({
      formData: { ...formData, stockType: activeKey || null }
    })
    setExportFormData({ ...formData, stockType: activeKey || null })
    setSourceStoreCode(formData.sourceStoreCode)
    setNo(formData.no)
  }
  const showAddCheckSheet = async $checkNo=>{
    console.log('新增调拨单');
    if ($checkNo) {
      props.history.push({
        pathname:'/inventory/product-transfers/edit',
        query:{
          checkNo: $checkNo,
          sourceStoreCode,
          type: 'edit',
        }
      })
    } else {
      let _checkNo = await getCheckNo()
      props.history.push({
        pathname:'/inventory/product-transfers/edit',
        query:{
          checkNo: _checkNo,
          sourceStoreCode,
          type: 'add'
        }
      })
    }
  }
  const exportData = async () => {
    if (selectedItems.length > 0) {
      const api = activeKey == 'in'?service.inventory.allocationInExport: service.inventory.allocationOutExport
      try {
        let res = await api({ids: selectedItems, ...exportFormData})
        let fileName =
          `商品调${activeKey=='in'?'入':'出'}导出单 + ${Utils.parseTime(Date.parse(new Date()))}.xlsx`
        Utils.download(res, fileName)
      }catch (e){
        console.log(e)
      }
    } else {
      const api = activeKey == 'in'?service.inventory.allocationInExport: service.inventory.allocationOutExport
      try {
        let res = await api({ids: [], ...exportFormData})
        let fileName =
          `商品调${activeKey=='in'?'入':'出'}导出单 + ${Utils.parseTime(Date.parse(new Date()))}.xlsx`
        Utils.download(res, fileName)
      }catch (e){
        console.log(e)
      }
    }
  }
  const btns = (
    <Space>
      <AuthComponent authKey={checkBillBaseKey + 'create'}>
        {activeKey === 'out' && <Button
          icon={<PlusOutlined />}
          onClick={() => showAddCheckSheet()}
          type='primary'>
          新增调拨单
        </Button>}
      </AuthComponent>
      <AuthComponent authKey={checkBillBaseKey + activeKey +'/' + 'export'}>
        <Button type='primary' icon={<DownloadOutlined />} onClick={exportData}>
          导出
        </Button>
      </AuthComponent>
    </Space>
  )
  return(
    <>
      <Tabs activeKey={activeKey} onChange={setActiveKey}>
        {tabs.map(item => (
          <Tabs.TabPane tab={item.tab} key={item.key}></Tabs.TabPane>
        ))}
      </Tabs>
      <ProductTransfersListBasicForm
        stockType={activeKey}
        no={no}
        getList={queryBaseList}>
      </ProductTransfersListBasicForm>
      <Card style={{ marginTop: 20 }}>
        <div style={{ marginBottom: 20 }}>{btns}</div>
        <TransfersListTable
          allocationType={activeKey}
          pageData={pageData}
          rowSelection={{
            onChange: setSelectedItems,
            selectedRowKeys: selectedItems
          }}
          getList={getList}
          loading={loading}
        />
      </Card>
    </>
  )
}
